export default "__VITE_ASSET__ChROGITx__"